import { render, staticRenderFns } from "./MassMediaSlide.vue?vue&type=template&id=353e76c0&"
import script from "./MassMediaSlide.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MassMediaSlide.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MassMediaSlide.vue?vue&type=style&index=0&id=353e76c0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353e76c0')) {
      api.createRecord('353e76c0', component.options)
    } else {
      api.reload('353e76c0', component.options)
    }
    module.hot.accept("./MassMediaSlide.vue?vue&type=template&id=353e76c0&", function () {
      api.rerender('353e76c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/mobile/MassMediaSlide.vue"
export default component.exports